import type { TenantPrinterWithDetails } from '@maker-toolchest/shared';
import { Package } from 'lucide-react';

interface AccessorySlotDisplayProps {
  printer: TenantPrinterWithDetails;
  className?: string;
}

export function AccessorySlotDisplay({ printer, className = '' }: AccessorySlotDisplayProps) {
  return (
    <div className={`grid gap-4 md:grid-cols-2 ${className}`}>
      {/* Active Hotends */}
      <div>
        <h4 className="mb-2 text-sm font-medium text-foreground">Active Hotends ({printer.currentHotendSlots})</h4>
        <div className="overflow-hidden rounded-lg border border-border">
          <table className="min-w-full divide-y divide-border">
            <thead className="bg-background-subtle">
              <tr>
                <th className="px-3 py-1.5 text-left text-xs font-medium text-foreground-muted">
                  Hotend
                </th>
                <th className="px-3 py-1.5 text-left text-xs font-medium text-foreground-muted">
                  Nozzle
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background">
              <tr>
                <td colSpan={2} className="px-3 py-6">
                  <div className="text-center">
                    <Package className="mx-auto h-6 w-6 text-foreground-muted" />
                    <p className="mt-2 text-xs text-foreground-muted">No hotends configured</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Active Spools */}
      <div>
        <h4 className="mb-2 text-sm font-medium text-foreground">Active Spools ({printer.currentSpoolSlots})</h4>
        <div className="overflow-hidden rounded-lg border border-border">
          <table className="min-w-full divide-y divide-border">
            <thead className="bg-background-subtle">
              <tr>
                <th className="px-3 py-1.5 text-left text-xs font-medium text-foreground-muted">
                  Filament
                </th>
                <th className="px-3 py-1.5 text-left text-xs font-medium text-foreground-muted">
                  Color
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background">
              <tr>
                <td colSpan={2} className="px-3 py-6">
                  <div className="text-center">
                    <Package className="mx-auto h-6 w-6 text-foreground-muted" />
                    <p className="mt-2 text-xs text-foreground-muted">No spools loaded</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Other Accessories Count */}
      <div className="md:col-span-2">
        <h4 className="mb-2 text-sm font-medium text-foreground">Other Accessories</h4>
        <div className="rounded-lg border border-border bg-background-subtle p-3">
          <div className="text-xs text-foreground-muted mb-1">
            Installed Accessories
          </div>
          <div className="text-lg font-semibold text-foreground">
            {printer.currentAccessorySlots}
          </div>
        </div>
      </div>
    </div>
  );
}
